import React from 'react';

import { Nullable } from '@clearverify/types';

import { useGetEmployerBasicInfoQuery } from 'src/api';

export const useEmployerBasicInfo = (employerId: Nullable<string>) => {
  const { data, loading } = useGetEmployerBasicInfoQuery({
    variables: {
      id: String(employerId),
    },
    skip: !employerId,
  });

  const employer = React.useMemo(() => data?.getEmployerBasicInfo, [data?.getEmployerBasicInfo]);

  return { employer, loading };
};
